<template>
    <div class="w-screen h-screen bg-gray-200 flex items-center justify-center p-10">
        
        <article v-if="invite && invite.invite" class="bg-white rounded-lg shadow-xl flex flex-col items-center p-10 text-center w-full max-w-screen-sm">

            <a href="/"><logo variant="logo-small" class="w-12"/></a>

            <typography variant="h4" class="mt-4">You've been invited to join the <span class="text-primary">{{ invite.invite.projectName }}</span> project.</typography>

            <typography v-if="error" variant="p" class="text-error mt-2">This is not a valid invite, or your account's email does not match.</typography>
            <typography v-else variant="p" class="text-gray-500 mt-2">You were invited by {{ invite.invite.author }}</typography>

            <BaseButton v-if="!error" :disabled="error || isSubmitting" @click="acceptInvite" class="mt-8">Accept Invite</BaseButton>

            <router-link :to="{ name: 'Project' }" tag="button" v-else @click="createCollection = true" class="underline transition duration-150 text-gray-600 hover:text-primary dark-hover:text-primary-300 dark-hover:text-primary dark-hover:text-primary-300-300 focus:outline-none focus:shadow-outline rounded-sm mt-6 flex items-center py-2 px-5 border border-gray-300 rounded">
                <icon-svg icon="fat-arrow-left" class="w-3 mr-3"/>
                Return to Onsearch</router-link>
            

        </article>

    </div>
</template>

<script>
import { loading, error, myProjects, me } from '@/mixins'
import { getInvite, getAuthenticationState } from "@/graphql/queries";
import { acceptInvite, updateAuthenticationState } from "@/graphql/mutations";

export default {
    name: "AcceptInvites",
    metaInfo: {
      title: 'Accept Invite',
    },
    mixins: [ loading, error, myProjects, me ],
    data () {
        return {
            isSubmitting: false,
            error: false
        }
    },
    apollo: {
        authenticationState: {
            query: getAuthenticationState,
            result ({ data, loading }) {
                this.authenticationState = data.authenticationState
                if (!loading && !data.authenticationState.authenticated) {
                    this.$router.push({ 
                        name: "Login", 
                        query: {
                          redirectTo: `/invites/${this.$route.params.projectId}/${this.$route.params.inviteCode}`
                        } 
                    })
                }
            }
        },
        invite: {
            query: getInvite,
            variables() {
                return {
                    input: {
                        projectId: this.$route.params.projectId,
                        inviteCode: this.$route.params.inviteCode
                    }
                }
            },
            skip() {
                return this.$apollo.queries.authenticationState.loading || this.$apollo.queries.authenticationState.error || !this.authenticationState.authenticated;
            },
        },
    },
    methods: {
        async acceptInvite () {
            this.isSubmitting = true;

            try {

                this.$root.$emit('loading', true);
                await this.$apollo.mutate({
                    mutation: acceptInvite,
                    variables: {
                        input: {
                            projectId: this.$route.params.projectId,
                            inviteCode: this.$route.params.inviteCode
                        }
                    },
                });

                await this.$apollo.queries.me.refetch();
                await this.$apollo.queries.projects.refetch();


                await this.$apollo.mutate({
                    mutation: updateAuthenticationState,
                    variables: {
                        selectedProject: this.$route.params.projectId,
                        needsToOnboard: false
                    }
                });

                this.$router.push({ name: "Project" });

                this.$emit('close');
            } catch (error) {
                this.handleError(error);
            }

            this.$root.$emit('loading', false);
            
            this.isSubmitting = false;
        }
    }
}
</script>